import { render, staticRenderFns } from "./WeeklyCalendar.vue?vue&type=template&id=25c3ea07&scoped=true"
import script from "./WeeklyCalendar.vue?vue&type=script&lang=js"
export * from "./WeeklyCalendar.vue?vue&type=script&lang=js"
import style0 from "./WeeklyCalendar.vue?vue&type=style&index=0&id=25c3ea07&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c3ea07",
  null
  
)

export default component.exports